import moment from 'moment'

export function extendObj (obj, src) {
  for (var key in src) {
    if (src.hasOwnProperty(key)) obj[key] = src[key]
  }
  return obj
}

/**
     * @param fill {string} what to fill
     * @param number {number} how many times fill will be repeated. negative value appends
     * @return {string} the resulting string. if the input string is larger than padToSize, it will be returned as is
     */

export function fill (fill, size) {
  var str = ''
  for (var i = 0; i < size; i++) {
    str += fill
  }
  return str
}

/**
 * Creates an array of numbers from start up to end with steps.
 * @param start {number} The start of the range.
 * @param end {number} The end of the range.
 * @param step {number} The value to increment/decrement by
 * @returns {array} List of numbers
 */

export function range (start, end, step) {
  var list = []
  step = (!step ? 1 : 0)
  for (var i = start; i <= (start + end); i += step) {
    list.push(i)
  }
  return list
}

/**
 * Formats the date to the format for submit
 * @param value (unix timestamp)
 * @returns {string}
 */
export function formatDateForSubmit (value) {
  return '/Date(' + value + '+0000)/'
}

/**
 * Pads number with zeros according to a desired number of characters
 * @param value { number } the number to pad
 * @param desiredLength { number } the desired length of the number
 * @returns {string}
 */
export function zeroPadNumber (value, desiredLength) {
  var valueStr = value.toString()
  var valueFloat = parseFloat(valueStr.replace(',', '.').replace(' ', ''))
  var lengthOfReading = valueFloat.toString().length
  var formatLength = parseInt(desiredLength, 10)
  var difference = formatLength - lengthOfReading
  var padString = ''
  if (difference > 0) {
    for (var i = 0; i < difference; i++) {
      padString = '0' + padString
    }
  }
  return padString + valueFloat
}

export function mobileScrollToTop () {
  if (window.innerWidth < 601) {
    window.scrollTo(0, 0)
  } else {
    var appdiv = document.getElementById('app')
    this.scrollIntoView(appdiv)
  }
}

export function scrollIntoView (element) {
  element.scrollIntoView({behavior: 'auto', block: 'start', inline: 'nearest'})
}

export function getCurrentScript (id) {
  // get script by id, else get last script
  if (id) {
    return document.getElementById(id)
  } else {
    var scripts = document.querySelectorAll('script[data-lang]')
    return scripts[scripts.length - 1]
  }
}

export function dateToUnix (val) {
  var date = moment(val, 'DD.MM.YYYY')

  if (!date.isValid()) {
    date = moment(new Date())
  }

  return date.toDate().getTime()
}

export function dateFromUnix (val) {
  return moment.unix(val).toDate()
}

/* eslint-disable */
export function getOrientation(file, callback) {
  var reader = new FileReader();
  reader.onload = function(e) {
    var view = new DataView(e.target.result);
    if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
    var length = view.byteLength, offset = 2;
    while (offset < length) {
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xFFE1) {
        if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
        var little = view.getUint16(offset += 6, false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (var i = 0; i < tags; i++)
          if (view.getUint16(offset + (i * 12), little) == 0x0112)
            return callback(view.getUint16(offset + (i * 12) + 8, little));
      }
      else if ((marker & 0xFF00) != 0xFF00) break;
      else offset += view.getUint16(offset, false);
    }
    return callback(-1);
  };
  reader.readAsArrayBuffer(file);
}

/**
 * Formats checks if valid error object
 * @param value object
 * @returns object
 */
export function parseErrorObj (response) {
  if (typeof response.data === 'object') {
    return response.data

  } else {
    var newObj = {}
    newObj = {code: response.status, errorCode: response.status}
    newObj.parameters = {}
    newObj.parameters.errorCode = response.status
    return newObj
  }
}

export function arrayHasArray(arrayContainer, arrayToFind) {
  for (let array of arrayContainer) {
    let allValuesSame = true
    for (var i = array.length - 1; i >= 0; i--) {
      if(array[i] !== arrayToFind[i]) {
        allValuesSame = false
        break
      }
    }
    if(allValuesSame) {
      return true
    }
  }
  return false
}

export function redirectPost (url, data) {
    const form = document.createElement('form');
    document.body.appendChild(form);
    form.method = 'post';
    form.action = url;

    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    })

    form.submit();
}

export function validateSSN (ssn, t) {
  ssn = ssn.replace(/\s/g, '')
  const { valid, age, type } = kennitala.info(ssn)
  if (!ssn.match(/^\d{6}-?\d{4}$/) || !valid) {
    return false
  }

  if (type === 'person' && age < 18) {
    return false
  }

  return true
}

export function validateSsnInput(e) {
  if (isNaN(Number(e.target.value))) {
    e.target.value = e.target.value.slice(0, e.target.value.length - 1)
  }
  if (e.target.value.length > 10) {
    e.target.value = e.target.value.slice(0, 10)
  }
}

export function fixMeterDecimals (meter, value) {
  if (!isNaN(parseFloat(value))) {
    if (meter.aukastafaFjoldi < 1) {
      return value
    }
    
    var splits = value.trim().split(',')
    var digits = splits[0]
    var decimals = splits[1]

    if (decimals !== undefined) {
      decimals = decimals.slice(0, meter.aukastafaFjoldi)
    } else {
      decimals = '0'.repeat(meter.aukastafaFjoldi)
    }

    return digits + ',' + decimals
  } else {
    return value
  }
}



// WEBPACK FOOTER //
// ./src/lib/util.js